
function ifExist(obj, cb, def){
    let result;
    if(obj){
      result = cb(obj);
    }
    if(result){
        return result;
    }

    return def;
}

const byId = (state, id) => state.getIn(['customer', 'items', String(id)]);
const getById = byId

const _Id = (customer) => customer.getIn(['info', 'payload', 'id'], '');
const getId = (customer, defaultValue) => ifExist(customer, _Id, defaultValue);

const getDisplayId = (customer) => customer.getIn(['info', 'payload', 'company_customer_id'])

const _IsOnline = (customer) => customer.getIn(['info','isOnline'], '');
const getIsOnline = (customer, defaultValue) => ifExist(customer, _IsOnline, defaultValue);

const _Name = (customer) => {
    let name = customer.getIn(['info', 'payload', 'name']);
    if(!name)
        name = 'Besökare #' + getDisplayId(customer);
    return name
    }
const getName = (customer) => ifExist(customer, _Name);

const _Image = (customer) => customer.getIn(['info', 'payload', 'image_url']);
const getImage = (customer) => ifExist(customer, _Image, '/images/customer_icon_noborder.png')

const _Email = (customer) => customer.getIn(['info', 'payload', 'email'], '');
const getEmail = (customer, defaultValue) => ifExist(customer, _Email, defaultValue);

const _Phone = (customer) => customer.getIn(['info', 'payload', 'phone'], '');
const getPhone = (customer, defaultValue) => ifExist(customer, _Phone, defaultValue);

const _Note = (customer) => customer.getIn(['info', 'payload', 'note'], '');
const getNote = (customer, defaultValue) => ifExist(customer, _Note, defaultValue);

const _IsBlocked = (customer) => customer.getIn(['info', 'payload', 'is_blocked'], false);
const getIsBlocked = (customer, defaultValue) => ifExist(customer, _IsBlocked, defaultValue);

const _Tags = (customer) => customer.getIn(['info', 'payload', 'tags'], '');
const getTags= (customer, defaultValue) => ifExist(customer, _Tags, defaultValue);

const _Stats = (customer) => customer.get('stats');
const getStats = (customer, defaultValue) => ifExist(customer, _Stats, defaultValue);

const _Tickets= (customer) => customer.get('tickets');
const getTickets= (customer, defaultValue) => ifExist(customer, _Tickets, defaultValue);

const _CurrentUrl = (customer) => customer.getIn(['info', 'payload', 'current_url']);
const getCurrentUrl = (customer, defaultValue) => ifExist(customer, _CurrentUrl, defaultValue);

export default {
  getName, getEmail, getPhone,getNote, getTags, getStats,
  getId,
  byId, getById,
  getIsOnline, getIsBlocked,
  getTickets,
  getImage, getCurrentUrl
}



// WEBPACK FOOTER //
// ./src/model/Customer/selector.js